/**
 * [E8 2026-09-30, pakiet P6 FRONT] Etykiety dla człowieka — stany, rodzaje, źródła i cykle monitora wpisu do Wykazu KSC.
 * Kody pochodzą z serwera (Domain/Models/WykazKsc/WykazKscSlowniki.cs: WykazKscRodzajeSpraw, WykazKscStanySprawy, WykazKscZrodla,
 * WykazKscRoleOsob, WykazKscRodzajeZasobow, WykazKscCykleAtestacji, WykazKscStanyPrawa, WykazKscTrybyMonitora); tu tylko tłumaczenie
 * na ekran, żeby właściciel nie czytał `pismo_do_odczytu`. Kod spoza słownika → bez podkreśleń, nigdy pusto.
 */
export const RODZAJE_SPRAW = {
    zmiana_danych: "Zmiana danych wpisu",
    wezwanie_7k: "Wezwanie organu (art. 7k)",
    wpis_z_urzedu_7j: "Wpis z urzędu (art. 7j)",
    przeglad_statusu: "Przegląd statusu (art. 5 ust. 5)",
    wykreslenie: "Wykreślenie z Wykazu",
    atestacja: "Potwierdzenie zgodności pól",
    szkolenie_8e: "Szkolenie kierownika (art. 8e)",
    strona_www_art9: "Strona www (art. 9)",
    domena_wygasa: "Domena wygasa",
    certyfikat: "Certyfikat TLS",
    zrodlo_awaria: "Awaria źródła",
    przeglad_prawny: "Przegląd prawny",
    pismo_do_odczytu: "Pismo do odczytu (awizo)",
    zadanie_nadzor_53c: "Żądanie nadzorcze (art. 53c)",
    zastrzezenia_protokol_58: "Zastrzeżenia do protokołu (art. 58)",
    skarga_ppsa: "Skarga do WSA (PPSA)",
    ponowne_rozpatrzenie: "Wniosek o ponowne rozpatrzenie",
    mail_do_przejrzenia: "Mail do przejrzenia (kolejka ksc@)",
};

/** [E8-F1 §4] Rodzaje pism organów — sprawa `pismo_do_odczytu` po otwarciu pisma zmienia rodzaj na jeden z nich. */
export const PISMA_ORGANOW = ["wezwanie_7k", "zadanie_nadzor_53c", "zastrzezenia_protokol_58", "skarga_ppsa", "ponowne_rozpatrzenie", "wpis_z_urzedu_7j"];

/** Rodzaje, które człowiek zakłada RĘCZNIE (papier, pisma organów) — E8 §7 pkt 3. */
export const RODZAJE_RECZNE = ["pismo_do_odczytu", "wezwanie_7k", "wpis_z_urzedu_7j", "zadanie_nadzor_53c", "zastrzezenia_protokol_58", "skarga_ppsa", "ponowne_rozpatrzenie", "zmiana_danych"];

/**
 * Rodzaje spraw, które NIE idą przez wniosek do Wykazu i zamyka je człowiek ręcznie (stan `zamknieta` w szufladzie): awaria źródła,
 * przeglądy, szkolenie 8e, sprawy operacyjne www/domena/certyfikat, kolejka ksc@ i pisma organów. `zmiana_danych` i `wykreslenie`
 * zamykają się WYŁĄCZNIE przez wniosek z zaświadczeniem (D32/D38), `atestacja` — przez zapis atestacji (E8-F1 §2), a `pismo_do_odczytu`
 * najpierw dostaje właściwy rodzaj pisma (E8-F1 §4). Przegląd adwersarialny P6 pkt 3.
 */
export const RODZAJE_BEZ_WNIOSKU = ["przeglad_statusu", "szkolenie_8e", "strona_www_art9", "domena_wygasa", "certyfikat", "zrodlo_awaria", "przeglad_prawny", "mail_do_przejrzenia", ...PISMA_ORGANOW];

/**
 * Czy sprawę wolno zamknąć ręcznie (stan „zamknięta”) — reguła SERWERA, nie wymysł ekranu: `RozstrzygnijSpraweAsync` odmawia
 * zamknięcia sprawy BEZ wniosku („Sprawę bez wniosku można zakończyć tylko jako „nie dotyczy” z uzasadnieniem”) i każdego
 * zamknięcia bez uzasadnienia. [poprawki po przeglądzie KSC, krytyczne F106] Wcześniej ekran dopuszczał rodzaje „bez wniosku”
 * (RODZAJE_BEZ_WNIOSKU) — serwer odpowiadał wtedy zawsze 400, a atrapa testu tego nie umiała (zapadka na własny kształt).
 * Rodzaje bez wniosku kończy „Nie dotyczy” z uzasadnieniem.
 */
export const mozeZamknacRecznie = (sprawa) => !!sprawa && !!sprawa.wniosekId;

/** Rodzaj sprawy, któremu serwer pozwala zmienić rodzaj pisma (F108): wyłącznie „pismo do odczytu” (F1 §4). */
export const mozeZmienicRodzajPisma = (sprawa) => !!sprawa && sprawa.rodzaj === "pismo_do_odczytu";

export const STANY_SPRAWY = {
    nowa: "Nowa",
    nie_dotyczy: "Nie dotyczy",
    do_wniosku: "Do wniosku",
    wniosek_zlozony: "Wniosek złożony",
    zamknieta: "Zamknięta",
};

/** Stany końcowe — sprawa nieedytowalna (D12). */
export const STANY_KONCOWE = ["nie_dotyczy", "zamknieta"];

export const ZRODLA = {
    company: "Dane spółki (Firmy)",
    kadry: "Kadry mPracownika",
    krs: "KRS — odpis",
    biuletyn_krs: "KRS — Biuletyn",
    wl: "Biała lista VAT",
    ceidg: "CEIDG",
    gus_bir: "GUS BIR",
    rdap: "RDAP domen",
    dns: "DNS",
    ct: "Certificate Transparency",
    ripe: "RIPE",
    ovh: "OVH API",
    graph: "Microsoft Graph",
    skrzynka_ksc: "Skrzynka ksc@",
    eli: "ELI Sejmu",
    gov_pl: "gov.pl (Dz. Urz. MC, S46)",
    legislacja: "legislacja.gov.pl",
    cellar: "EUR-Lex (Cellar)",
    sejm: "Sejm — procesy legislacyjne",
    reczne: "Ręcznie",
};

export const ROLE_OSOB = { kontakt: "Osoba kontaktowa", admin_s46: "Administrator konta w S46" };
export const RODZAJE_ZASOBOW = { ipv4: "IPv4", ipv6: "IPv6", domena: "Domena", host: "Host" };
export const CYKLE_ATESTACJI = { kwartalnie: "Kwartalnie", rocznie: "Rocznie", przeglad_statusu: "Przy przeglądzie statusu" };
export const TYPY_REPREZENTACJI = { samodzielna: "Samodzielna (1 podpis)", laczna: "Łączna (2 podpisy)" };
export const STANY_PRAWA = { nowe: "Nowe", bez_wplywu: "Bez wpływu", wymaga_dzialan: "Wymaga działań" };
/* [P1 2026-10-01] „plan” na ekranie nic właścicielowi nie mówił — to tryb PRÓBNY (system liczy, nic nie wysyła), ta sama nazwa
   co w module procedur („Próbny — nic nie wysyłamy”). Kody `plan` / `pelny` na drucie bez zmian. */
export const TRYBY_MONITORA = { plan: "próbny", pelny: "pełny" };
export const RODZAJE_WNIOSKOW = { wpis: "Wpis", zmiana: "Zmiana wpisu", wykreslenie: "Wykreślenie" };
export const TRYBY_ZRODLA_POLA = { auto: "automat", reczne: "ręcznie", mieszane: "mieszane" };
export const RODZAJE_STRAZNIKOW = { zdarzenie: "zdarzenie", detektor: "sprawdzenie w rejestrze", atestacja: "potwierdzenie zgodności" };
export const KANALY_DORECZENIA = { ade: "e-Doręczenia (ADE)", s46: "S46", papier: "Papier (KPA)" };

export const etykieta = (mapa, kod) => (kod && mapa[kod]) || (kod ? String(kod).replace(/_/g, " ") : "—");

/** Polska odmiana po liczbie: odmien(1, ["pole","pola","pól"]) → „pole”, 3 → „pola”, 5 / 12 → „pól”. */
export const odmien = (n, [jeden, kilka, wiele]) => {
    const x = Math.abs(Number(n) || 0);
    if (x === 1) return jeden;
    const d = x % 10;
    const s = x % 100;
    return d >= 2 && d <= 4 && (s < 12 || s > 14) ? kilka : wiele;
};

/**
 * [P1 2026-10-01] Tekst z serwera bez kodów projektu w nawiasach („(D42)”, „(E8 §3)”, „(dopiero po krokach 13a F1)”) — właściciel ocenia
 * po ekranie, a kody nic mu nie mówią. Wycina wyłącznie NAWIAS zawierający kod (E\d, D\d\d, F\d); zwykłe nawiasy zostają.
 */
export const bezKodowProjektu = (tekst) => String(tekst ?? "")
    .replace(/\s*\([^()]*\b(?:E\d+|D\d{1,2}|F\d)\b[^()]*\)/g, "")
    .replace(/\s{2,}/g, " ")
    .trim();

/**
 * [P1 poprawki 2026-10-01, przegląd pkt 5] Słownik zamian dla tekstów, które PISZE SERWER (opis sprawy z automatu, uzasadnienie
 * zdarzenia prawnego, opis błędu źródła, przepis z kalendarza ustawowego). Automaty zapisują je zdaniami z kodami projektu
 * i żargonem („Migawka bazowa źródła (D36)…”, „nadawca uwierzytelniony spoza allowlisty”, „kluczem WykazKscAtestacja (F1 §2, D43)”),
 * a szuflady pokazywały je wprost. Kolejność ma znaczenie: najpierw całe zwroty, potem pojedyncze słowa.
 * Ta tablica z definicji zawiera słowa, które WYCINA — zapadka źródłowa (wykazKsc.pierwszeUruchomienie.1001) pomija dokładnie ten blok.
 */
export const ZAMIANY_TEKSTU_SERWERA = [
    [/Migawka bazowa źródła/g, "Stan wyjściowy z pierwszego sprawdzenia"],
    [/pierwsza migawka/gi, "pierwsze sprawdzenie"],
    [/migawki bazowe/gi, "stan wyjściowy"],
    [/spoza allowlisty/gi, "spoza zaufanych domen"],
    [/z allowlisty/gi, "z zaufanych domen"],
    [/allowlist\w*/gi, "lista zaufanych domen"],
    [/\bWykazKscAtestacja\b/g, "„Wykaz KSC — potwierdzenie zgodności”"],
    [/\bWykazKscRedakcja\b/g, "„Wykaz KSC — redakcja”"],
    [/\bWykazKscPodglad\b/g, "„Wykaz KSC — podgląd”"],
    [/\bNIEuwierzytelniony\b/g, "nieuwierzytelniony"],
    [/\bmigawk(?:a|ę)\b/gi, "odczyt"],
    [/\bmigawki\b/gi, "odczytu"],
    [/\bmigawek\b/gi, "odczytów"],
    [/\bmigawką\b/gi, "odczytem"],
    // Kod projektu poza nawiasem („…E8 §3”, „F1 §2”) — wycinamy sam kod z paragrafem, zdanie zostaje.
    [/\s*\b(?:E\d+|F\d)\s*§\s*[\d.]+/g, ""],
];

/**
 * [ui1006, projekt 2.8 i F133] STARE NAZWY MIEJSC w tekstach serwera (e-maile, powiadomienia, opisy błędów źródeł) → nowe nazwy.
 * Jedno źródło dla rejestru (`config/obszary/wykazKsc.js → stareNazwyMiejsc`) i dla `tekstSerwera` — serwera nie zmieniamy.
 * [poprawki po przeglądzie KSC] Wcześniej pary stały tylko w rejestrze i nikt ich nie używał (test sprawdzał sam rejestr).
 */
export const STARE_NAZWY_MIEJSC = [
    [/Integracje techniczne\s*(?:→|->)\s*Wykaz KSC/g, "Integracje → Systemy zewnętrzne → Wykaz KSC"],
    [/Wykaz KSC\s*(?:→|->)\s*Źródła(?! danych)/g, "Wykaz KSC → Rejestry → Źródła danych"],
    [/Wykaz KSC\s*(?:→|->)\s*Prawo/g, "Wykaz KSC → Praca → Zmiany prawa"],
];

/** Tekst z serwera na ekran: bez kodów projektu w nawiasach, bez żargonu automatów i ze współczesnymi nazwami miejsc. Pusto → pusto. */
export const tekstSerwera = (tekst) => {
    if (tekst == null || tekst === "") return "";
    let wynik = bezKodowProjektu(tekst);
    ZAMIANY_TEKSTU_SERWERA.forEach(([wzor, zamiana]) => { wynik = wynik.replace(wzor, zamiana); });
    STARE_NAZWY_MIEJSC.forEach(([wzor, zamiana]) => { wynik = wynik.replace(wzor, zamiana); });
    return wynik.replace(/\s{2,}/g, " ").trim();
};

/** [P1 poprawki 2026-10-01] Jak często system sprawdza źródło — zamiast słowa „takt” i kodu `co_4h`. */
export const TAKTY_ZRODEL = { dziennie: "codziennie", tygodniowo: "co tydzień", miesiecznie: "co miesiąc", co_4h: "co 4 godziny", natychmiast: "na bieżąco" };

/**
 * [P1 2026-10-01] Ustawienia modułu opisane zwykłymi zdaniami. Serwer (WykazKscUstawienia.Definicje) podaje etykiety z kodami
 * projektu i słowami w rodzaju „allowlista”, „takt”, „cap” — ekran bierze nazwę stąd, a dla klucza spoza tej mapy tekst serwera
 * bez kodów w nawiasach (`bezKodowProjektu`). Wartości (`plan`, `pelny`, `tak`, `nie`) na drucie bez zmian — zmienia się tylko napis.
 */
export const OPISY_USTAWIEN = {
    "WykazKsc.Tryb": {
        etykieta: "Powiadomienia i przypomnienia",
        opis: "Próbny: system codziennie sprawdza dane spółek i zakłada sprawy z terminem, ale niczego nie wysyła. Pełny: przypomnienia o terminach, przypomnienia do Zarządu po terminie i zestawienia wychodzą do adresatów.",
        opcje: { plan: "Próbny — nic nie wysyłamy, tylko liczymy", pelny: "Pełny — przypomnienia i e-maile wychodzą" },
    },
    "WykazKsc.SkrzynkaNadawcza": { etykieta: "Skrzynka, z której moduł wysyła e-maile", opis: "Adres skrzynki — e-maile modułu wychodzą wyłącznie z niej." },
    "WykazKsc.SkrzynkaZdarzen": { etykieta: "Skrzynka urzędowa (ksc@)", opis: "Adres skrzynki, z której system czyta awiza e-Doręczeń i wiadomości z wykazu oraz S46." },
    "WykazKsc.AllowlistaNadawcow": { etykieta: "Zaufane domeny nadawców", opis: "Domeny urzędów, których wiadomości system traktuje jako urzędowe." },
    "WykazKsc.SlowaKluczowe": { etykieta: "Słowa, po których wiadomość idzie do przejrzenia", opis: "Wiadomość spoza zaufanych domen, w której jest to słowo, trafia do sprawdzenia przez człowieka." },
    "WykazKsc.AdresaciEskalacji": { etykieta: "Kogo powiadamiamy po terminie (Zarząd)", opis: "Osoby wybrane z listy; pusta lista = członkowie Zarządu spółki." },
    "WykazKsc.AdresaciZestawienia": { etykieta: "Adresaci zestawienia tygodniowego", opis: "Zarząd, Dyrektor Finansowy, Dział IT — osoby wybrane z listy." },
    "WykazKsc.EskalacjeMaks": { etykieta: "Ile razy najwyżej przypominamy Zarządowi po terminie", opis: "Po terminie przypomnienie idzie codziennie, ale nie więcej razy niż tu." },
    "WykazKsc.AlertSprawozdanWlaczony": { etykieta: "Alert braku sprawozdania w KRS", opis: "Włącz po uzgodnieniu z księgowością — inaczej pojawią się fałszywe alarmy." },
    "WykazKsc.GodzinaMonitora": { etykieta: "Godzina sprawdzania danych spółek", opis: "O której godzinie (czas polski) system porównuje dane spółek z rejestrami i Microsoft 365." },
    "WykazKsc.GodzinaPrawa": { etykieta: "Godzina sprawdzania zmian prawa", opis: "O której godzinie system sprawdza nowe akty prawne i komunikaty." },
    "WykazKsc.GodzinaTerminow": { etykieta: "Godzina przypomnień o terminach", opis: "O której godzinie idą przypomnienia: 7, 3 i 1 dzień przed terminem, w dniu terminu i po terminie." },
    "WykazKsc.WebhookTeams": { etykieta: "Alerty w kanale Teams", opis: "Czy wysyłać alerty także do kanału Teams (adres kanału ustawia administrator w Integracjach)." },
    "WykazKsc.SmsWlaczony": { etykieta: "SMS do Zarządu po terminie", opis: "Czy po terminie wysyłać do Zarządu także SMS." },
    "WykazKsc.ObserwowaneAkty": { etykieta: "Obserwowane akty prawne", opis: "Oznaczenia aktów z ELI albo EUR-Lex — system śledzi ich zmiany." },
    "WykazKsc.SpolkaWiodaca": { etykieta: "Spółka dla spraw wspólnych", opis: "Spółka, do której trafiają sprawy bez rozpoznanej spółki (np. wiadomość ksc@ bez nazwy spółki). Puste: pierwsza spółka z kartą wpisu w kolejności kartoteki." },
    "WykazKsc.SpolkiPozaWykazem": { etykieta: "Spółki poza wykazem", opis: "Spółki z kartoteki, które nie są wpisane do wykazu podmiotów KSC. Krok „Karty wpisu spółek” w uruchomieniu nie każe zakładać im karty i bez nich jest zrobiony." },
};

/**
 * [P1 poprawki 2026-10-01, przegląd pkt 1 — krytyczne] W grupie jest sześć spółek, a do wykazu podmiotów KSC wpisane są cztery.
 * Która spółka NIE jest w wykazie, wie tylko człowiek — i to musi żyć na serwerze, nie w przeglądarce: ustawienie modułu
 * `WykazKsc.SpolkiPozaWykazem` (id spółek po przecinku, ten sam mechanizm AppSettings co tryb). Bez tego karta „Pierwsze
 * uruchomienie” nigdy by nie zniknęła („4 z 6”) i namawiała do założenia karty spółce, której ustawa nie dotyczy — a karta
 * wpisu uruchamia monitor, sprawy z terminem 14 dni i (w trybie pełnym) e-maile do Zarządu.
 */
export const USTAWIENIE_SPOLKI_POZA_WYKAZEM = "WykazKsc.SpolkiPozaWykazem";

/** „3, 5,x” → Set {3, 5} (id > 0). */
export const idsSpolekPozaWykazem = (wartosc) => new Set(String(wartosc ?? "")
    .split(",").map((x) => Number(String(x).trim())).filter((n) => Number.isInteger(n) && n > 0));

/**
 * [domknięcie luk 2026-10-01, krytyk: „ten sam fakt — czy spółka podlega KSC/NIS2 — ustawia się w dwóch niezależnych miejscach”]
 * „Spółka objęta ustawą” (Procedury i bezpieczeństwo → Ustawienia, domyślnie „nie”) i „Nie jest w wykazie” (Wykaz KSC → Pierwsze
 * uruchomienie, domyślnie każda spółka JEST w wykazie) opisują jeden fakt: spółka z wykazu podmiotów KSC podlega ustawie, a spółka
 * objęta ustawą musi być w wykazie. Dopóki właściciel nie zdecyduje o jednym przełączniku, oba ekrany pokazują stan drugiego modułu
 * i ostrzegają przy sprzeczności (ta funkcja), a wiersz KSC w „Czego brakuje” oznacza ją przy spółce.
 * @returns {null|"objeta_poza_wykazem"|"w_wykazie_nieobjeta"} null = zgodne albo nie wiadomo (brak danych drugiego modułu)
 */
export const sprzecznoscObjeciaUstawa = ({ objeta = null, pozaWykazem = null } = {}) => {
    if (objeta == null || pozaWykazem == null) return null;
    if (objeta && pozaWykazem) return "objeta_poza_wykazem";
    if (!objeta && !pozaWykazem) return "w_wykazie_nieobjeta";
    return null;
};
export const ZDANIA_SPRZECZNOSCI_USTAWY = Object.freeze({
    objeta_poza_wykazem: "W Procedurach i bezpieczeństwie spółka jest objęta ustawą, a w Wykazie KSC oznaczona jako spoza wykazu — sprawdź, które oznaczenie jest prawdziwe.",
    w_wykazie_nieobjeta: "W Wykazie KSC spółka jest w wykazie, a w Procedurach i bezpieczeństwie nie jest oznaczona jako objęta ustawą — sprawdź, które oznaczenie jest prawdziwe.",
});
/* [paczka KSC] Zdanie czyta też strona Procedur (jej test szukał „„Nie jest w wykazie” w Wykazie KSC”) — nazwa oznaczenia zostaje,
   a miejsce wskazuje nowe: przełącznik „poza wykazem” w „Ustawienia → Spółki objęte wykazem”. */
export const ZDANIE_DWA_PRZELACZNIKI = "Ten sam fakt ustawia się w dwóch miejscach: „Spółka objęta ustawą” w Procedurach i bezpieczeństwie (Ustawienia) i „Nie jest w wykazie” w Wykazie KSC (Ustawienia → Spółki objęte wykazem, przełącznik „poza wykazem”). Spółka z wykazu KSC podlega ustawie — oba oznaczenia powinny się zgadzać.";

/** Set/tablica id → wartość ustawienia „3,5” (posortowana, bez powtórzeń). */
export const wartoscSpolekPozaWykazem = (ids) => [...new Set([...(ids || [])].map(Number).filter((n) => Number.isInteger(n) && n > 0))]
    .sort((a, b) => a - b).join(",");

/** Napis ustawienia na ekranie: { etykieta, opis, opcja(wartosc) } — z mapy wyżej albo z serwera bez kodów projektu. */
export const opisUstawienia = (u) => {
    const znany = OPISY_USTAWIEN[u?.klucz] || null;
    return {
        etykieta: znany?.etykieta || bezKodowProjektu(u?.etykieta),
        opis: znany?.opis || bezKodowProjektu(u?.opis),
        opcja: (wartosc) => znany?.opcje?.[wartosc] || String(wartosc ?? ""),
    };
};

/**
 * [P1 2026-10-01] Źródła, które potrzebują HASŁA (klucza API, tokenu, skrzynki) wpisanego przez administratora w Integracjach.
 * Kody z ZRODLA wyżej (= WykazKscZrodla na serwerze).
 */
export const ZRODLA_Z_HASLEM = ["gus_bir", "ceidg", "ovh", "skrzynka_ksc"];

/**
 * [P1 2026-10-01] Stan jednego wiersza GET /wykaz-ksc/zrodla na ekranie.
 *
 * Serwer NIE odróżnia „brak hasła” od „sprawne”: detektor bez klucza (albo bez danych wejściowych, np. bez NIP-u dostawcy) pomija się
 * po cichu, zapisuje SUKCES i nie tworzy migawki (WykazKscMonitor + DetektorPomocnik.Pominieto). Jedyny ślad w odpowiedzi: udany
 * przebieg i ZERO migawek. Taki wiersz pokazujemy jako „nic nie pobrano” (źródło z hasłem) / „nic do sprawdzenia” (bez hasła)
 * — nigdy jako „sprawne” i nigdy jako „awaria”. Zasada „brak hasła ≠ awaria”.
 *
 * [P1 poprawki 2026-10-01, przegląd pkt 2] To jest PODPOWIEDŹ, nie fakt: CEIDG czyta tylko przy NIP-ach dostawców prowadzących
 * działalność, skrzynka ksc@ — dopiero gdy przyjdzie wiadomość, więc poprawnie ustawione źródło też bywa „nic nie pobrano”. Dlatego
 * napis mówi, co sprawdzić, a karta „Pierwsze uruchomienie” NIE opiera na nim zniknięcia (krok 3 blokują tylko awarie i błędy).
 * Docelowo serwer powinien podawać powód pominięcia (brak klucza / brak danych) w odpowiedzi źródeł.
 */
export const ETYKIETA_NIC_NIE_POBRANO = "nic nie pobrano — sprawdź hasło w Integracjach";

export const stanZrodla = (z) => {
    if (!z) return { kod: "nieznany", etykieta: "jeszcze nie sprawdzane", ton: "szary" };
    if (z.wAwarii) return { kod: "awaria", etykieta: "awaria", ton: "blad" };
    if ((z.kolejneBledy || 0) > 0) return { kod: "bledy", etykieta: `błędy: ${z.kolejneBledy}`, ton: "uwaga" };
    if ((z.migawek || 0) === 0) {
        if (!z.ostatniSukcesAt) return { kod: "nieznany", etykieta: "jeszcze nie sprawdzane", ton: "szary" };
        return ZRODLA_Z_HASLEM.includes(z.zrodlo)
            ? { kod: "brak_hasla", etykieta: ETYKIETA_NIC_NIE_POBRANO, ton: "uwaga" }
            : { kod: "pomijane", etykieta: "nic do sprawdzenia", ton: "szary" };
    }
    return { kod: "sprawne", etykieta: "sprawne", ton: "ok" };
};

/**
 * [P1 poprawki 2026-10-01, przegląd pkt 2] Czy krok „Hasła do rejestrów” jest zrobiony: false WYŁĄCZNIE przy prawdziwej awarii albo
 * błędach (fakt z serwera); true, gdy każde źródło z hasłem pobiera dane; w każdym innym przypadku null („nie wiadomo”) — heurystyka
 * „nic nie pobrano” nie trzyma karty na ekranie.
 */
export const krokHasel = (hasla) => {
    if (!Array.isArray(hasla) || hasla.length === 0) return null;
    if (hasla.some((h) => h.kod === "awaria" || h.kod === "bledy")) return false;
    if (hasla.every((h) => h.kod === "sprawne")) return true;
    return null;
};

/** Stan każdego źródła z hasłem zebrany ze wszystkich jego wierszy (per spółka): działa, jeśli choć jeden wiersz pobiera dane. */
export const stanZrodelZHaslem = (zrodla) => ZRODLA_Z_HASLEM.map((kod) => {
    const wiersze = (Array.isArray(zrodla) ? zrodla : []).filter((z) => z.zrodlo === kod);
    if (wiersze.length === 0) return { zrodlo: kod, ...stanZrodla(null) };
    const stany = wiersze.map(stanZrodla);
    const kolejnosc = ["sprawne", "awaria", "bledy", "brak_hasla", "pomijane", "nieznany"];
    const najlepszy = stany.find((x) => x.kod === "sprawne") || [...stany].sort((a, b) => kolejnosc.indexOf(a.kod) - kolejnosc.indexOf(b.kod))[0];
    return { zrodlo: kod, ...najlepszy };
});

/** Ton znacznika stanu sprawy: po terminie = błąd, nowa = uwaga, do wniosku = akcent, końcowe = szary. */
export const tonStanuSprawy = (sprawa) => {
    if (!sprawa) return "szary";
    if (sprawa.poTerminie && !STANY_KONCOWE.includes(sprawa.status)) return "blad";
    if (sprawa.status === "nowa") return "uwaga";
    if (sprawa.status === "do_wniosku" || sprawa.status === "wniosek_zlozony") return "";
    return "szary";
};

export const tonStanuPrawa = (stan) => (stan === "nowe" ? "uwaga" : stan === "wymaga_dzialan" ? "blad" : "ok");

const dwa = (n) => String(n).padStart(2, "0");

/** DateOnly z serwera („2026-10-14”) albo ISO → „14.10.2026”; pusto → „—”. */
export const dataPl = (wartosc) => {
    if (!wartosc) return "—";
    const tekst = String(wartosc);
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(tekst);
    if (m) return `${m[3]}.${m[2]}.${m[1]}`;
    const d = new Date(tekst);
    return Number.isNaN(d.getTime()) ? tekst : `${dwa(d.getDate())}.${dwa(d.getMonth() + 1)}.${d.getFullYear()}`;
};

/** DateTime UTC z bazy → data i godzina w strefie przeglądarki (czas polski). */
export const dataCzasPl = (wartosc) => {
    if (!wartosc) return "—";
    const d = new Date(String(wartosc));
    if (Number.isNaN(d.getTime())) return String(wartosc);
    return `${dwa(d.getDate())}.${dwa(d.getMonth() + 1)}.${d.getFullYear()} ${dwa(d.getHours())}:${dwa(d.getMinutes())}`;
};

/** Zdanie o terminie: „za 5 dni”, „dziś”, „3 dni po terminie”. */
export const zdanieOTerminie = (sprawa) => {
    if (!sprawa || sprawa.dniDoTerminu == null) return "";
    const n = sprawa.dniDoTerminu;
    if (n === 0) return "dziś";
    if (n > 0) return `za ${n} ${n === 1 ? "dzień" : "dni"}`;
    return `${-n} ${-n === 1 ? "dzień" : "dni"} po terminie`;
};

/** Świeżość źródeł na kaflu: ostatni sukces < 26 h = OK, < 50 h = uwaga, dalej = awaria (E8 D36: 2 doby bez sukcesu). */
export const tonSwiezosci = (ostatniSukcesAt, teraz = new Date()) => {
    if (!ostatniSukcesAt) return "szary";
    const d = new Date(String(ostatniSukcesAt));
    if (Number.isNaN(d.getTime())) return "szary";
    const godzin = (teraz.getTime() - d.getTime()) / 36e5;
    if (godzin <= 26) return "ok";
    if (godzin <= 50) return "uwaga";
    return "blad";
};

/** Kolejność sekcji formularza Wykazu A–K (E8 D34) — karta spółki sortuje pola po sekcji, potem po kodzie. */
export const SEKCJE = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"];
export const porownajPola = (a, b) => {
    const ia = SEKCJE.indexOf(String(a.sekcja || "").toUpperCase());
    const ib = SEKCJE.indexOf(String(b.sekcja || "").toUpperCase());
    if (ia !== ib) return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    const na = /pkt(\d+)/.exec(a.kod || "");
    const nb = /pkt(\d+)/.exec(b.kod || "");
    if (na && nb) return Number(na[1]) - Number(nb[1]);
    if (na) return -1;
    if (nb) return 1;
    return String(a.kod).localeCompare(String(b.kod));
};

/** Wartość deklarowana pola — serwer trzyma kanoniczny JSON; na ekran idzie tekst bez cudzysłowów i nawiasów listy. */
export const wartoscNaEkran = (wartosc) => {
    if (wartosc == null || wartosc === "") return "—";
    const tekst = String(wartosc).trim();
    try {
        const parsed = JSON.parse(tekst);
        if (Array.isArray(parsed)) return parsed.length ? parsed.map((x) => (typeof x === "object" ? JSON.stringify(x) : String(x))).join(", ") : "—";
        if (parsed && typeof parsed === "object") return Object.entries(parsed).map(([k, v]) => `${k}: ${v}`).join("; ");
        return String(parsed);
    } catch {
        return tekst;
    }
};
